import React from "react";
import * as SheetPrimitive from "@/components/ui/sheet";

const { Sheet, SheetContent, SheetHeader, SheetTitle } = SheetPrimitive as any;

export function Drawer({
  open,
  onOpenChange,
  title,
  side = "right",
  children,
  testid,
}: {
  open: boolean;
  onOpenChange: (o: boolean) => void;
  title?: string;
  side?: "left" | "right" | "top" | "bottom";
  children: React.ReactNode;
  testid?: string;
}) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side={side} data-testid={testid}>
        {title && (
          <SheetHeader>
            <SheetTitle>{title}</SheetTitle>
          </SheetHeader>
        )}
        <div className="mt-4">{children}</div>
      </SheetContent>
    </Sheet>
  );
}
